<script setup lang="ts">
import type { Page } from '~/types/Page';
import { createError } from '#app';

const route = useRoute();
const slug = computed(() => route.params.slug as string);
const { getItems } = useDirectusItems();
const { directusLocale } = useGlobalData();

const { data: pages } = await useAsyncData(
    () => `page-${slug.value}`,
    () =>
        getItems<Page[]>({
            collection: 'pages',
            params: {
                filter: {
                    slug: {
                        _eq: slug.value,
                    },
                },
                fields: ['id', 'title', 'content', 'translations.title', 'translations.content'],
                deep: {
                    translations: {
                        _filter: {
                            languages_code: { _eq: directusLocale.value },
                        },
                    },
                },
                limit: 1,
            },
        }),
    {
        watch: [slug],
    }
);

if (!pages.value || pages.value.length === 0) {
    throw createError({ statusCode: 404, statusMessage: 'Page not found' });
}

const page = computed(() => {
    return pages.value?.[0] as Page | undefined;
});

watch(
    page,
    (newPage) => {
        if (newPage) {
            useHead({
                title: newPage.translations[0]?.title || newPage.title || '',
            });
        }
    },
    { immediate: true }
);

definePageMeta({
    middleware: 'auth',
});
</script>

<template>
    <div class="container mx-auto mb-10 max-w-4xl">
        <h1 class="text-4xl text-white font-heading">{{ page?.translations[0]?.title || page?.title }}</h1>
    </div>
    <div class="container mx-auto mt-4 max-w-4xl">
        <div v-html="page?.translations[0]?.content || page?.content" class="content"></div>
    </div>
</template>
